module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "vw-card-head-link",
    attrs: {
      "href": _vm.href
    }
  }, [_c('div', {
    staticClass: "vw-card-head-link-wrapper"
  }, [_c('img', {
    staticClass: "vw-card-head-link-wrapper-img",
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vw-card-head-link-wrapper-title"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5f7bbdac!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/card-head.vue
// module id = 250
// module chunks = 0